// extracted by mini-css-extract-plugin
export default {"tab-control":"JcAyP2_q","grow":"k4eDdC96","vertical":"VMCZubpU"};